/**
 * Country Utilities
 * Consolidated from countryMapping.ts, countryTranslations.ts, and countryUtils.ts
 */

export const countryTranslations: Record<string, string> = {
  Afghanistan: "Afghanistan",
  Albania: "Albanien",
  Algeria: "Algeriet",
  Andorra: "Andorra",
  Angola: "Angola",
  "Antigua and Barbuda": "Antigua och Barbuda",
  Argentina: "Argentina",
  Armenia: "Armenien",
  Australia: "Australien",
  Austria: "Österrike",
  Azerbaijan: "Azerbajdzjan",
  Bahamas: "Bahamas",
  Bahrain: "Bahrain",
  Bangladesh: "Bangladesh",
  Barbados: "Barbados",
  Belarus: "Vitryssland",
  Belgium: "Belgien",
  Belize: "Belize",
  Benin: "Benin",
  Bhutan: "Bhutan",
  Bolivia: "Bolivia",
  "Bosnia and Herzegovina": "Bosnien och Hercegovina",
  Botswana: "Botswana",
  Brazil: "Brasilien",
  Brunei: "Brunei",
  Bulgaria: "Bulgarien",
  "Burkina Faso": "Burkina Faso",
  Burundi: "Burundi",
  "Cabo Verde": "Kap Verde",
  Cambodia: "Kambodja",
  Cameroon: "Kamerun",
  Canada: "Kanada",
  "Central African Republic": "Centralafrikanska republiken",
  Chad: "Tchad",
  Chile: "Chile",
  China: "Kina",
  Colombia: "Colombia",
  Comoros: "Komorerna",
  "Congo (Congo-Brazzaville)": "Kongo-Brazzaville",
  "Costa Rica": "Costa Rica",
  Croatia: "Kroatien",
  Cuba: "Kuba",
  Cyprus: "Cypern",
  "Czechia (Czech Republic)": "Tjeckien",
  "Democratic Republic of the Congo": "Kongo-Kinshasa",
  Denmark: "Danmark",
  Djibouti: "Djibouti",
  Dominica: "Dominica",
  "Dominican Republic": "Dominikanska republiken",
  Ecuador: "Ecuador",
  Egypt: "Egypten",
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Ekvatorialguinea",
  Eritrea: "Eritrea",
  Estonia: "Estland",
  Eswatini: "Eswatini",
  Ethiopia: "Etiopien",
  Fiji: "Fiji",
  Finland: "Finland",
  France: "Frankrike",
  Gabon: "Gabon",
  Gambia: "Gambia",
  Georgia: "Georgien",
  Germany: "Tyskland",
  Ghana: "Ghana",
  Greece: "Grekland",
  Grenada: "Grenada",
  Guatemala: "Guatemala",
  Guinea: "Guinea",
  "Guinea-Bissau": "Guinea-Bissau",
  Guyana: "Guyana",
  Haiti: "Haiti",
  "Holy See": "Vatikanstaten",
  Honduras: "Honduras",
  Hungary: "Ungern",
  Iceland: "Island",
  India: "Indien",
  Indonesia: "Indonesien",
  Iran: "Iran",
  Iraq: "Irak",
  Ireland: "Irland",
  Israel: "Israel",
  Italy: "Italien",
  Jamaica: "Jamaica",
  Japan: "Japan",
  Jordan: "Jordanien",
  Kazakhstan: "Kazakstan",
  Kenya: "Kenya",
  Kiribati: "Kiribati",
  Kuwait: "Kuwait",
  Kyrgyzstan: "Kirgizistan",
  Laos: "Laos",
  Latvia: "Lettland",
  Lebanon: "Libanon",
  Lesotho: "Lesotho",
  Liberia: "Liberia",
  Libya: "Libyen",
  Liechtenstein: "Liechtenstein",
  Lithuania: "Litauen",
  Luxembourg: "Luxemburg",
  Madagascar: "Madagaskar",
  Malawi: "Malawi",
  Malaysia: "Malaysia",
  Maldives: "Maldiverna",
  Mali: "Mali",
  Malta: "Malta",
  "Marshall Islands": "Marshallöarna",
  Mauritania: "Mauritanien",
  Mauritius: "Mauritius",
  Mexico: "Mexiko",
  Micronesia: "Mikronesien",
  Moldova: "Moldavien",
  Monaco: "Monaco",
  Mongolia: "Mongoliet",
  Montenegro: "Montenegro",
  Morocco: "Marocko",
  Mozambique: "Mocambique",
  "Myanmar (formerly Burma)": "Myanmar",
  Namibia: "Namibia",
  Nauru: "Nauru",
  Nepal: "Nepal",
  Netherlands: "Nederländerna",
  "New Zealand": "Nya Zeeland",
  Nicaragua: "Nicaragua",
  Niger: "Niger",
  Nigeria: "Nigeria",
  "North Korea": "Nordkorea",
  "North Macedonia": "Nordmakedonien",
  Norway: "Norge",
  Oman: "Oman",
  Pakistan: "Pakistan",
  Palau: "Palau",
  "Palestine State": "Palestina",
  Panama: "Panama",
  "Papua New Guinea": "Papua Nya Guinea",
  Paraguay: "Paraguay",
  Peru: "Peru",
  Philippines: "Filippinerna",
  Poland: "Polen",
  Portugal: "Portugal",
  Qatar: "Qatar",
  Romania: "Rumänien",
  Russia: "Ryssland",
  Rwanda: "Rwanda",
  "Saint Kitts and Nevis": "Saint Kitts och Nevis",
  "Saint Lucia": "Saint Lucia",
  "Saint Vincent and the Grenadines": "Saint Vincent och Grenadinerna",
  Samoa: "Samoa",
  "San Marino": "San Marino",
  "Sao Tome and Principe": "Sao Tome och Principe",
  "Saudi Arabia": "Saudiarabien",
  Senegal: "Senegal",
  Serbia: "Serbien",
  Seychelles: "Seychellerna",
  "Sierra Leone": "Sierra Leone",
  Singapore: "Singapore",
  Slovakia: "Slovakien",
  Slovenia: "Slovenien",
  "Solomon Islands": "Salomonöarna",
  Somalia: "Somalia",
  "South Africa": "Sydafrika",
  "South Korea": "Sydkorea",
  "South Sudan": "Sydsudan",
  Spain: "Spanien",
  "Sri Lanka": "Sri Lanka",
  Sudan: "Sudan",
  Suriname: "Surinam",
  Sweden: "Sverige",
  Switzerland: "Schweiz",
  Syria: "Syrien",
  Tajikistan: "Tadzjikistan",
  Tanzania: "Tanzania",
  Thailand: "Thailand",
  "Timor-Leste": "Östtimor",
  Togo: "Togo",
  Tonga: "Tonga",
  "Trinidad and Tobago": "Trinidad och Tobago",
  Tunisia: "Tunisien",
  Turkey: "Turkiet",
  Turkmenistan: "Turkmenistan",
  Tuvalu: "Tuvalu",
  Uganda: "Uganda",
  Ukraine: "Ukraina",
  "United Arab Emirates": "Förenade Arabemiraten",
  "United Kingdom": "Storbritannien",
  "United States": "USA",
  Uruguay: "Uruguay",
  Uzbekistan: "Uzbekistan",
  Vanuatu: "Vanuatu",
  Venezuela: "Venezuela",
  Vietnam: "Vietnam",
  Yemen: "Jemen",
  Zambia: "Zambia",
  Zimbabwe: "Zimbabwe",
  "The Netherlands": "Nederländerna",
  USA: "USA",
  UK: "Storbritannien",
  "South Georgia and the South Sandwich Islands": "Sydgeorgien",
  "Svalbard and Jan Mayen": "Svalbard och Jan Mayen",
  "Åland Islands": "Åland",
  "Faroe Islands": "Färöarna",
  Greenland: "Grönland",
};

export const countryMapping: Record<string, string> = {
  // English mappings
  "The United Kingdom of Great Britain and Northern Ireland": "UK",
  "United Kingdom": "UK",
  "United States of America": "USA",
  "United States": "USA",
  "Russian Federation": "Russia",
  "Syrian Arab Republic": "Syria",
  "Iran (Islamic Republic of)": "Iran",
  "Korea (Democratic People's Republic of)": "North Korea",
  "Korea (Republic of)": "South Korea",
  "Tanzania, United Republic of": "Tanzania",
  "Venezuela (Bolivarian Republic of)": "Venezuela",
  "Bolivia (Plurinational State of)": "Bolivia",
  "Moldova (Republic of)": "Moldova",
  "Congo (Democratic Republic of the)": "DR Congo",
  "Macedonia (the former Yugoslav Republic of)": "North Macedonia",

  // Common variations (from countryUtils)
  "United Kingdom Of Great Britain And Northern Ireland": "United Kingdom",
  "The United Kingdom": "United Kingdom",
  "The United States": "United States",
  USA: "United States",
  "U.S.A.": "United States",

  "The Netherlands": "Netherlands",
  "The Czech Republic": "Czech Republic",
  "The Philippines": "Philippines",
  "Republic of Korea": "South Korea",
  "Democratic People's Republic of Korea": "North Korea",

  // Swedish mappings
  "Storbritannien och Nordirland": "Storbritannien",
  "Förenade Konungariket": "Storbritannien",
  "Förenta Staterna": "USA",
  "Ryska Federationen": "Ryssland",
  "Förenta kungariket Storbritannien och Nordirland": "Storbritannien",
  "Amerikas förenta stater": "USA",
  
  // Specific long names from API/Screenshot
  // Specific long names from API/Screenshot
  "The United States Of America": "USA",
  "The United Kingdom Of Great Britain And Northern Ireland": "UK",
  "The Russian Federation": "Russia",
};

export const getShortCountryName = (fullName: string): string => {
  if (!fullName) return "";
  return countryMapping[fullName] || fullName;
};

/**
 * Get display-friendly country name
 * Maps long official country names to shorter, more UI-friendly versions.
 */
export function getDisplayCountryName(
  countryName: string | undefined,
  fallbackName?: string,
): string {
  if (!countryName) {
    return fallbackName || "";
  }

  // Check for direct override
  if (countryMapping[countryName]) {
    return countryMapping[countryName];
  }

  // Check case-insensitive override
  const lowerName = countryName.toLowerCase();
  const overrideKey = Object.keys(countryMapping).find(
    (key) => key.toLowerCase() === lowerName,
  );

  if (overrideKey) {
    return countryMapping[overrideKey];
  }

  return countryName;
}

/**
 * Truncate a string to a maximum length, adding ellipsis if needed
 */
